<template>
  <div class="container mt-5">
    <div class="card text-center floating-card ">
    <h4 class="floating-content">Distribución por Peso</h4>
    <div class="grafico mx-auto">
      <apexchart width="380" type="line" :options="options" :series="series"></apexchart>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '../store/config';

export default {
  data() {
    return {
      niños: [],
      pesoPromedioPorCanton: {},
      errorLoadingNiños: null,
      options: {},
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    loadNiños() {
      axios
        .get(`${BASE_URL}/api/control/reporte`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        })
        .then(response => {
          this.niños = response.data;
          this.calcularPesoPromedioPorCanton();
          this.actualizarGrafico();
        })
        .catch(error => {
          this.errorLoadingNiños = 'Error al cargar niños. Por favor, inténtalo de nuevo.';
          console.error('Error al cargar niños:', error);
        });
    },
    calcularPesoPromedioPorCanton() {
      this.pesoPromedioPorCanton = {};

      this.niños.forEach(niño => {
        const canton = niño.ninoId.canton;
        const peso = niño.peso;

        if (!this.pesoPromedioPorCanton[canton]) {
          this.pesoPromedioPorCanton[canton] = { totalPeso: 0, cantidadNiños: 0 };
        }

        this.pesoPromedioPorCanton[canton].totalPeso += peso;
        this.pesoPromedioPorCanton[canton].cantidadNiños += 1;
      });

      for (const canton in this.pesoPromedioPorCanton) {
        const promedio =
          this.pesoPromedioPorCanton[canton].totalPeso / this.pesoPromedioPorCanton[canton].cantidadNiños;
        this.pesoPromedioPorCanton[canton] = promedio.toFixed(2);
      }
    },
    actualizarGrafico() {
      const cantonesUnicos = Object.keys(this.pesoPromedioPorCanton);
      const pesoPromedio = cantonesUnicos.map(canton => parseFloat(this.pesoPromedioPorCanton[canton]))
      this.options = {
        series: [
          {
            name: 'Peso(kg)',
            type: 'line',
            data: pesoPromedio
          },
        ],
        chart: {
          height: 350,
          width: 370,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          text: 'Peso promedio de niños/as por cantones',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: cantonesUnicos.sort(),
          title: {
            text: 'Cantones',
          },
        },
        yaxis:{
          title: {
            text: 'Peso (kg)',
          },
        }
        
      };
    },
  },
  mounted() {
    this.loadNiños();
    this.actualizarGrafico();
  },
};
</script>

<style >
 .floating-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
    transition: box-shadow 0.3s ease-in-out;
  }
  
  .floating-content {
    transform: translate3d(0, -5px, 0);
    transition: transform 0.3s ease-in-out;
  }

  .grafico{
    margin-left: 80px;
  }
</style>
